module.exports = __webpack_public_path__ + "static/media/image3.d6e8d864.jpg";